// One row in the regional book / company list. Green tint + check
// when the property is an Apollo customer.

import { Link } from 'react-router-dom';

export default function PropertyRow({ property, current = false }) {
  const apollo = !!property.apollo_customer;
  const cls = [
    'directory-row',
    apollo ? 'directory-row--apollo' : '',
    current ? 'directory-row--current' : '',
  ].filter(Boolean).join(' ');

  return (
    <Link to={`/sales/directory/property/${encodeURIComponent(property.id)}`} className={cls}>
      <span className="directory-row__check" aria-hidden="true">
        {apollo ? <span className="directory-row__check-icon">&#10003;</span> : null}
      </span>
      <span className="directory-row__name">
        {property.name}
        {current ? <span className="directory-row__current-tag">  Current</span> : null}
      </span>
      <span className="directory-row__city">{property.city || ''}</span>
    </Link>
  );
}
